export const methodNames = {
    'USPS_GROUND_ADVANTAGE': 'USPS Ground Advantage',
    'PRIORITY_MAIL': 'USPS Priority Mail',
    'PRIORITY_MAIL_EXPRESS': 'USPS Priority Mail Express',
    'FEDEX_GROUND': 'FedEx Ground',
    'FEDEX_EXPRESS_SAVER': 'FedEx Express Saver',
    'FEDEX_2_DAY': 'FedEx 2 Day',
    'FEDEX_STANDARD_OVERNIGHT': 'FedEx Standard Overnight',
    'UPS_GROUND': 'UPS Ground',
    'UPS_3_DAY_SELECT': 'UPS 3 Day Select',
    'UPS_2ND_DAY_AIR': 'UPS 2nd Day Air',
    'UPS_NEXT_DAY_AIR': 'UPS Next Day Air',
    'CANADA_POST_REGULAR_PARCEL': 'Canada Post Regular Parcel',
    'CANADA_POST_EXPEDITED_PARCEL': 'Canada Post Expedited Parcel',
    'CANADA_POST_XPRESSPOST': 'Canada Post Xpresspost',
    'CANADA_POST_XPRESSPOST_CERTIFIED': 'Canada Post Xpresspost Certified',
    'CANADA_POST_PRIORITY': 'Canada Post Priority',
    'CANADA_POST_LIBRARY_MATERIALS': 'Canada Post Library Materials',
    'CANADA_POST_EXPEDITED_PARCEL_USA': 'Canada Post Expedited Parcel USA',
    'CANADA_POST_SMALL_PACKET_USA_AIR': 'Canada Post Small Packet USA Air',
    'CANADA_POST_TRACKED_PACKET_USA': 'Canada Post Tracked Packet USA',
    'CANADA_POST_TRACKED_PACKET_USA_LVM': 'Canada Post Tracked Packet USA (LVM)',
    'CANADA_POST_XPRESSPOST_USA': 'Canada Post Xpresspost USA',
    'CANADA_POST_XPRESSPOST_INTERNATIONAL': 'Canada Post Xpresspost International',
    'CANADA_POST_INTERNATIONAL_PARCEL_AIR': 'Canada Post International Parcel Air',
    'CANADA_POST_INTERNATIONAL_PARCEL_SURFACE':
        'Canada Post International Parcel Surface',
    'CANADA_POST_SMALL_PACKET_INTERNATIONAL_AIR':
        'Canada Post Small Packet International Air',
    'CANADA_POST_SMALL_PACKET_INTERNATIONAL_SURFACE':
        'Canada Post Small Packet International Surface',
    'CANADA_POST_TRACKED_PACKET_INTERNATIONAL':
        'Canada Post Tracked Packet International',
    'PRINTIFY_STANDARD': 'Printify Standard',
    'PRINTIFY_EXPRESS': 'Printify Express',
    'PRINTIFY_PRIORITY': 'Printify Priority',
    'PRINTIFY_ECONOMY': 'Printify Economy',
    'GENERIC_GROUND': 'Generic Ground',
    'GENERIC_PRIORITY': 'Generic Priority',
    'GENERIC_EXPRESS': 'Generic Express',
    'GENERIC_OVERNIGHT': 'Generic Overnight',
    'LOCAL_PICKUP': 'Local Pickup'
};
export default function niceNameForShippingMethod(method) {
    return methodNames[method] || method;
};
